// CallUI.js
import React from "react"; //  { useEffect, useState } 
import { Button, Typography } from "antd";
import {
    AudioMutedOutlined,
    AudioOutlined,
} from "@ant-design/icons";
import { useCall } from "./CallPage";
import { CallCancelIcon } from "../../../../components/Icons/Icons";
import CallLogPopup from '../../Popup/CallLogPopup'

const { Title, Text } = Typography;

function CallUI() {
    const { cancelCall, isCalling, activeCallNumber, callLogData, triggerFromButton, setCallStatusF, callStatus, muteCall, unmuteCall, isMuted, callEntityData, callStatusF } = useCall();
    // const [callDuration, setCallDuration] = useState(0);
    // const [timerId, setTimerId] = useState(null);

    // start/stop timer when connected
    // useEffect(() => {
    //     if (callStatus === "connected") {
    //         const id = setInterval(() => {
    //             setCallDuration((prev) => prev + 1);
    //         }, 1000);
    //         setTimerId(id);
    //     } else {
    //         clearInterval(timerId);
    //         setTimerId(null);
    //         setCallDuration(0);
    //     }
    //     return () => clearInterval(timerId);
    // }, [callStatus]);

    // Format call duration (mm:ss)
    // const formatTime = (secs) => {
    //     const m = Math.floor(secs / 60).toString().padStart(2, "0");
    //     const s = (secs % 60).toString().padStart(2, "0");
    //     return `${m}:${s}`;
    // };

    const closefucntion = () => {
        setCallStatusF()
    }
    return (
        <>{
            isCalling ?
                <div
                    style={{
                        position: "fixed",
                        bottom: "20px",
                        right: "20px",
                        background: "rgba(0,0,0,0.85)",
                        borderRadius: "16px",
                        padding: "20px",
                        color: "white",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "250px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
                        zIndex: 9999,
                    }}
                >
                    {/* Number + Status */}
                    <div style={{ textAlign: "center", marginBottom: "15px" }}>
                        {callEntityData ?
                            <>
                                <Title level={4} style={{ color: "white", margin: "0px 0px 10px" }}>
                                    {callEntityData.for === "User" ? `${callEntityData.data.firstName} ${callEntityData.data.lastName}` :
                                        callEntityData.for === "Lead" ? `${callEntityData.data.first_name} ${callEntityData.data.last_name}` :
                                            callEntityData.for === "Contact" ? `${callEntityData.data.first_name} ${callEntityData.data.last_name}` :
                                                callEntityData.for === "Case" ? `${callEntityData.data.name}` :
                                                    callEntityData.for === "Ass" ? `${callEntityData.data.assitant_name}` : ""}
                                </Title>
                                <Text style={{ color: "gray", fontSize: "14px", display: "block" }}>
                                    {activeCallNumber || "Unknown Number"}
                                </Text></>
                            : <Title level={4} style={{ color: "white", margin: "0px 0px 10px" }}>
                                {activeCallNumber || "Unknown Number"}
                            </Title>}

                        <Text style={{ color: "gray", fontSize: "12px" }}>
                            {callStatus === "connected"
                                // ? formatTime(callDuration)
                                ? "Connected"
                                : callStatus || "Calling..."}
                        </Text>
                    </div>

                    {/* Buttons */}
                    <div style={{ display: "flex", gap: "20px", marginTop: 10 }}>
                        <Button
                            shape="circle"
                            className="mute-Call"
                            size="large"
                            onClick={isMuted ? unmuteCall : muteCall}
                            icon={isMuted ? <AudioMutedOutlined /> : <AudioOutlined />}
                        />
                        <Button
                            shape="circle"
                            size="large"
                            onClick={cancelCall}
                            className="cancel-Call"
                            icon={<CallCancelIcon width="25" height="30" marginRight={1} marginBottom={1} />}
                        />
                    </div>
                </div> : <></>}
            {callStatusF === "Active" && <CallLogPopup setCallLogPopup={closefucntion} callLogPopup={callStatusF === "Active"} popupType="Create" UrlId={["Call"]} CallData={callEntityData} setNaCTrigger={triggerFromButton} activeCallNumber={activeCallNumber} page="CallUi" callLogData={callLogData}
            // callLogPopup={callLogData?.callLogId && callStatusF === "Active"}
            />}
        </>
    );

}

export default CallUI;
